import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { FixedCell } from "../../../components/tables/StandardTable";
import VirtualTable, { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { Main, ThemedSpan } from "../../../components/utilities";
import { toCurrency } from "../../../helpers/numbers";

const TransactionTypeOptions = [
    ["PURCH", "PRDR2", "CORPIN"],
    ["SALE", "STFRO", "CORPOUT"]
];

const HubwiseActionToggle = React.forwardRef(({ children, onClick }, ref) => (
    <FontAwesomeIcon
        ref={ref}
        className="has-pointer"
        icon="fa-ellipsis"
        onClick={(e) => {
            typeof e.preventDefault === 'function' && e.preventDefault();
            onClick(e);
        }}
    />
));

const HubwiseTransactionRow = ({ data, index, style, patchRow }) => {
    const { height } = style;

    if (index >= data.length || data[index] == null)
        return <TableLoadingRow style={{ height }} />;

    const {
        id,
        platformAccountId,
        platformAccountName,
        sedol,
        assetName,
        isin,
        platformTransactionType,
        quantity,
        transactionValue,
        // TODO More properties from DTO?
        // platformClientName,
        // platformTransactionId,
        // tradeDate,
        // expense,
        // proceeds,
    } = data[index];

    const availableTransactionTypeOptions = TransactionTypeOptions.find(opts => opts.includes(platformTransactionType));

    return <tr className="align-middle" index={index} style={{ height }}>
        <FixedCell width={30} className="text-truncate">
            {platformAccountId} - {platformAccountName}
        </FixedCell>
        <FixedCell width={30}>
            <p className="m-0 lh-1 text-truncate">
                {assetName}<br />
                <ThemedSpan variant="muted" className="fs-smallest">{sedol} - {isin}</ThemedSpan>
            </p>
        </FixedCell>
        <FixedCell width={10} className="text-truncate">
            {platformTransactionType}
        </FixedCell>
        <FixedCell width={10} className="text-end">{quantity}</FixedCell>
        <FixedCell width={10} className="text-end">{toCurrency(transactionValue, 2)}</FixedCell>
        <FixedCell width={10} className="text-end">
            <Dropdown className="caret-off w-100" drop="end">
                <Dropdown.Toggle as={HubwiseActionToggle} />
                <Dropdown.Menu>
                    {availableTransactionTypeOptions.map(type => (
                        <Dropdown.Item
                            key={type}
                            disabled={type === platformTransactionType}
                            onClick={() => patchRow(id, type)}
                        >
                            {type} {type === platformTransactionType && <FontAwesomeIcon icon="check" />}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </FixedCell>
    </tr>
};

const HubwiseTransactionsGrid = ({
    patchTransaction,
    results,
    totalCount,
    isClearing,
    isError,
    error,
    isRowLoaded,
    loadMore,
    reload
}) => {

    if (isError && !isClearing)
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={reload} />
        </ErrorMessageWrapper>

    if (totalCount === 0)
        return <Main>
            <div className="p-3">
                No Hubwise Transactions found.
            </div>
        </Main>

    return <VirtualTable
        enableScrollTracking={false}
        loadMoreItems={loadMore}
        row={(props) => <HubwiseTransactionRow patchRow={patchTransaction} {...props} />}
        itemSize={42}
        itemCount={results.length === totalCount ? totalCount : results.length + 10}
        itemData={[...results]}
        isItemLoaded={isRowLoaded}
        header={
            <thead>
                <tr>
                    <th>Account</th>
                    <th>Asset</th>
                    <th>Trans. Type</th>
                    <th className="text-end">Quantity</th>
                    <th className="text-end">Value</th>
                    <th className="text-end">Edit Type</th>
                </tr>
            </thead>
        }
    />
}

export default HubwiseTransactionsGrid;